import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const textualStyle = {
  maxWidth: "900px",
  margin: "0 auto",
  padding: "8px",
  background: "var(--color-surface-1)",
  border: "1px solid rgba(255, 255, 255, 0.05)",
  lineHeight: "1.9",
  color: "var(--color-text-secondary)",
};

const TermsAndConditions = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [btnHover, setBtnHover] = useState(false);

  const handleGrievanceClick = () => {
    if (user) {
      navigate("/contact#grievance-redressal");
    } else {
      navigate("/login");
    }
  };
  return (
    <div style={textualStyle}>
      <h2
        style={{
          color: "var(--color-text-primary)",
          marginBottom: "10px",
          borderBottom: "1px solid var(--color-border-light, rgba(255,255,255,0.1))",
          paddingBottom: "15px",
        }}
      >
        Terms & Conditions
      </h2>

      <h3
        style={{
          color: "#f97316",
          fontSize: "1.2rem",
          marginBottom: "15px",
          fontWeight: "600",
        }}
      >
        Regard Traders – Transparent B2B Wholesale Trading Policies
      </h3>

      <p style={{ marginBottom: "25px" }}>
        Namaste aur Regard Traders par vyapar karne ke liye dhanyawad. Hamare niyam aur shartein retail vyapariyon ki suraksha aur transparent business ke liye banayi gayi hain.
      </p>

      <h3 style={{ color: "var(--color-text-primary)", marginTop: "30px", marginBottom: "10px" }}>
        1. Platform Identity & B2B Role
      </h3>
      <p style={{ marginBottom: "20px" }}>
        Yeh platform (<a href="http://www.regardtraders.in/" target="_blank" rel="noreferrer" style={{ color: "#f97316", textDecoration: "underline" }}>www.regardtraders.in</a>) Regard Traders dwara sanchalit ek multi-vendor B2B wholesale marketplace hai. Hum desh bhar ke verified manufacturers, direct importers aur wholesale suppliers ko retail dukandaron se jodte hain. Yeh platform strictly commercial wholesale buyers ke liye hai; hum individual end-consumers ko retail sale nahi karte.
      </p>

      <h3 style={{ color: "var(--color-text-primary)", marginTop: "30px", marginBottom: "10px" }}>
        2. Flexible Payment Model: 20% Token Money + 80% COD
      </h3>
      <p style={{ marginBottom: "15px" }}>
        Dukandaron ki suvidha aur surakshit vyapar ke liye hamara payment model behad asaan aur surakshit hai:
      </p>
      <ul style={{ paddingLeft: "25px", marginBottom: "20px" }}>
        <li style={{ marginBottom: "10px" }}>
          <strong style={{ color: "#f97316" }}>20% Token Money (Order Confirmation):</strong> Order place karte samay invoice ka sirf 20% token amount jama karna hota hai, jisse supplier aapka stock confirm aur pack kare.
        </li>
        <li style={{ marginBottom: "10px" }}>
          <strong style={{ color: "#f97316" }}>Remaining 80% Balance on Delivery (COD):</strong> Baaki ka 80% balance amount aapko tab pay karna hai jab parcel aapki dukan par deliver ho (Cash ya UPI ke zariye).
        </li>
        <li style={{ marginBottom: "10px" }}>
          <strong style={{ color: "#f97316" }}>Safe Packing Confirmation:</strong> Dispatch se pehle aapko WhatsApp ya buyer portal par parcel ke sealed carton aur digital weighing scale ki photo bheji jati hai, jisse aapko tasalli rahe ki aapka pura maal sahi aur surakshit pack ho gaya hai.
        </li>
      </ul>

      <h3 style={{ color: "var(--color-text-primary)", marginTop: "30px", marginBottom: "10px" }}>
        3. Order Cancellation & Token Refund
      </h3>
      <ul style={{ paddingLeft: "25px", marginBottom: "20px" }}>
        <li style={{ marginBottom: "10px" }}>
          Agar kisi supplier ke paas stock available na hone ki wajah se order cancel hota hai, toh aapka poora 20% token amount bina kisi deduction ke 3–5 business days ke andar aapke original payment mode mein refund kar diya jayega.
        </li>
        <li style={{ marginBottom: "10px" }}>
          Agar parcel dispatch hone ke baad buyer bina kisi valid kaaran ke delivery lene se inkaar karta hai, toh standard two-way transport freight charge token money se adjust kiya jayega.
        </li>
      </ul>

      <h3 style={{ color: "var(--color-text-primary)", marginTop: "30px", marginBottom: "10px" }}>
        4. Damage, Shortage & Mandatory Opening Video Niyam
      </h3>
      <p style={{ marginBottom: "15px" }}>
        Regard Traders par har vyapar bharose aur transparency ke sath hota hai. Maal aapki dukan tak sahi salamat pahuche, iski poori koshish ki jaati hai. Lekin raste mein kisi bhi transit loss ya damage se bachne ke liye yeh niyam anivarya (mandatory) hai:
      </p>
      
      <div style={{ background: "var(--color-surface-2)", padding: "20px", borderRadius: "12px", marginBottom: "20px" }}>
        <p style={{ marginBottom: "10px" }}>
          <strong style={{ color: "#f97316" }}>360-Degree Continuous Opening Video:</strong><br />
          Jab transport ya courier se parcel aapki dukan par pahuche, toh dabba kholne (unboxing) se pehle se lekar poora maal bahar nikalne tak ka ek continuous video shoot karein.
        </p>

        <p style={{ marginBottom: "8px" }}>
          <strong style={{ color: "#f97316" }}>Video Shoot Kaise Karein:</strong>
        </p>
        <ol style={{ paddingLeft: "25px", marginBottom: "15px" }}>
          <li style={{ marginBottom: "6px" }}>
            Video shuru hote hi pehle dabbe ke charon taraf (360-degree) camera ghumayein taaki dikhe ki dabba pehle se phata ya khula hua toh nahi hai, aur shipping label saaf dikhe.
          </li>
          <li style={{ marginBottom: "6px" }}>
            Bina video pause ya cut kiye, sealed tape ko kaat kar dabba kholein.
          </li>
          <li style={{ marginBottom: "6px" }}>
            Dabbe ke andar se ek-ek item nikal kar count aur check karein.
          </li>
        </ol>

        <p style={{ marginBottom: "10px" }}>
          <strong style={{ color: "#f97316" }}>Claim Process (48 Ghante ke Andar):</strong><br />
          Agar parcel open karte waqt koi piece toota hua (damaged), defective, ya count mein kam (shortage) nikalta hai, toh yeh opening video delivery ke 48 ghante ke andar hamare official WhatsApp number (+91 72229 94585) par share karein.
        </p>

        <p style={{ marginBottom: "10px" }}>
          <strong style={{ color: "#f97316" }}>Turant Samadhan (Refund / Replacement):</strong><br />
          Opening video dekhte hi hamari support team bina kisi behes ke turant claim approve karegi—aur aapka nuksaan refund ya agle order mein credit ke zariye adjust kar diya jayega.
        </p>

        <p style={{ margin: 0, fontStyle: "italic", color: "var(--color-text-primary)" }}>
          <strong style={{ color: "#f97316" }}>Dhyan Dein:</strong> Bina continuous opening video ke damage ya missing item ka koi bhi claim transport company aur insurance dwara reject ho jata hai, isliye delivery ke waqt opening video banana anivarya hai.
        </p>
      </div>

      <h3 style={{ color: "var(--color-text-primary)", marginTop: "30px", marginBottom: "10px" }}>
        5. Multi-Hub Dispatches & Shipping
      </h3>
      <ul style={{ paddingLeft: "25px", marginBottom: "20px" }}>
        <li style={{ marginBottom: "10px" }}>
          Regard Traders alag-alag commercial manufacturing hubs (Delhi NCR, Surat, Mumbai, Ludhiana aadi) ke verified suppliers ko jodta hai.
        </li>
        <li style={{ marginBottom: "10px" }}>
          Agar aapne alag-alag hubs se maal chuna hai, toh unke cartons alag-alag transport tracking number ke sath alag dispatch ho sakte hain. Har parcel ki tracking details aapke portal par update hoti rahengi.
        </li>
      </ul>

      <h3 style={{ color: "var(--color-text-primary)", marginTop: "30px", marginBottom: "10px" }}>
        6. Customer Helpdesk & Support
      </h3>
      <div style={{ background: "var(--color-surface-2)", padding: "20px", borderRadius: "12px", marginBottom: "20px", lineHeight: "1.8" }}>
        <p style={{ marginBottom: "15px" }}>
          Kisi bhi order update, bilty details ya complaint escalation ke liye hamare Grievance Redressal desk se sampark karein:
        </p>
        <button
          onClick={handleGrievanceClick}
          onMouseEnter={() => setBtnHover(true)}
          onMouseLeave={() => setBtnHover(false)}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            padding: "11px 24px",
            background: btnHover
              ? "linear-gradient(135deg, #ea580c 0%, #c2410c 100%)"
              : "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
            color: "#ffffff",
            border: "none",
            borderRadius: "8px",
            fontWeight: "600",
            fontSize: "0.95rem",
            cursor: "pointer",
            boxShadow: btnHover
              ? "0 6px 20px rgba(249, 115, 22, 0.45)"
              : "0 4px 12px rgba(249, 115, 22, 0.25)",
            transform: btnHover ? "translateY(-2px)" : "translateY(0)",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          Grievance Redressal
        </button>
      </div>
    </div>
  );
};

export default TermsAndConditions;
